export const environment = {
  production: true,
  redirectLoginPage: false,
  redirectLoginUrl: "",
};
